// 左上のアプリメニュー（キャンバス名パネル）の省略表示状態を localStorage に保存する。

const KEY = "refinement-canvas:app-menu:collapsed";

export function loadAppMenuCollapsed(): boolean {
  try {
    // 既定は展開（従来どおり全ボタンを表示）。明示的に省略("1")を保存した場合のみ省略表示で開始する。
    // 不正値や localStorage 例外時も既定（展開）へフォールバックする。
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function saveAppMenuCollapsed(collapsed: boolean): void {
  try {
    window.localStorage.setItem(KEY, collapsed ? "1" : "0");
  } catch {
    // ignore
  }
}
